// extracted by mini-css-extract-plugin
module.exports = {"row_wrapper":"articlesBreadCrumbs_row_wrapper__2T3YE","breadcrumbs":"articlesBreadCrumbs_breadcrumbs__2-3N4"};